import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="hero-inner">
        <div className="hero-eyebrow">Enterprise Network Infrastructure</div>
        <h1 className="hero-headline">
          {props.data ? props.data.title : "Infrastructure Engineered for Performance."}
        </h1>
        <p className="hero-sub">
          {props.data ? props.data.paragraph : "Loading..."}
        </p>
        <div className="hero-actions">
          <a href="#contact" className="btn-primary page-scroll">
            Request a Quote
          </a>
          <a href="#portfolio" className="btn-secondary page-scroll">
            View Projects
          </a>
        </div>
        <div className="hero-stats">
          <div className="hero-stat">
            <span>{props.data ? props.data.stat1 : "150+ Deployments"}</span>
          </div>
          <div className="hero-stat">
            <span>{props.data ? props.data.stat2 : "Cisco & Fortinet Certified"}</span>
          </div>
          <div className="hero-stat">
            <span>{props.data ? props.data.stat3 : "Texas DIR Contract"}</span>
          </div>
        </div>
      </div>
    </header>
  );
};
